export interface ChipOption {
  label: string;
  value: string;
}

interface FilterChipsProps {
  options: ChipOption[];
  value: string;
  onChange: (value: string) => void;
  label?: string;
}

export default function FilterChips({ options, value, onChange, label }: FilterChipsProps) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {label && <span className="mr-1 text-sm text-foreground-500">{label}</span>}
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          onClick={() => onChange(option.value)}
          className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm transition-colors ${
            value === option.value
              ? "bg-secondary-500 text-background-50"
              : "bg-secondary-100 text-secondary-900 hover:bg-secondary-200"
          }`}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}